<template>
    <div class="all-order">
        <div class="all-order-content">
            <div style="padding: 20px;width: 60%;" v-if="creationTime">
                <el-descriptions title="" :column="1" border>
                    <el-descriptions-item label="光地" v-if="list[0].remark">是</el-descriptions-item>
                    <el-descriptions-item label="增加展墙" v-if="list[1].remark">是</el-descriptions-item>
                    <el-descriptions-item label="拆除展墙，请注明要拆除的展墙两侧的展位号" v-if="list[2].remark">是</el-descriptions-item>
                    <el-descriptions-item label="其他要求">{{ list[3].otherRemark }}</el-descriptions-item>
                </el-descriptions>

            </div>

            <div class="" v-else>
                <el-empty description="展商还未提交此内容">
                    <p>截止时间为：{{ timeValue }}，可提醒展商及时提交信息</p>
                </el-empty>
            </div>
        </div>
    </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import imgUpload from "@components/imgUpload/imgUpload.vue";
import { validator } from "@/other/validator";
import config from "@assets/config.json";

export default {
    name: "exhibition-info-catalogue",
    props:{
        timeValue:String
    },
    data () {
        return {
            formList: [],
            loading: false,
            creationTime:"",
            list: [
                { name: '光地', remark: false, },
                { name: '增加展墙', remark: false, },
                { name: '拆除展墙，请注明要拆除的展墙两侧的展位号', remark: false, },
                { name: '其它要求', otherRemark: "" },
            ]
        };
    },
    components: {
        // imgUpload,
    },
    computed: {
        ...mapGetters({
            formHeaders: "getFormHeaders",
            uploadUrl: "getUploadUrl",
            joinInfo: "loginModule/getJoinInfo",
            company: "loginModule/getCompany",
            exhibition: "loginModule/getExhibition",

            exhibitor: "loginModule/getExhibitor",
        }),
        queryId () {
            return this.$route.query.id;
        },
       
    },
    created () {
         
        // this.init();
        this.init2();
    },
    methods: {
        ...mapActions({

            downFile: "exhibitionModule/downFile",

            setManageSettingQ: 'hostSetModule/setManageSettingQ', //
            standardboothconstructionchangerecordPost: "exhibitionModuleY/standardboothconstructionchangerecordPost",
            standardboothconstructionchangerecordGet: "exhibitionModuleY/standardboothconstructionchangerecordGet",
        }),
        goDetail () {
            this.$router.push('/exhibition/index/order/detail-order');
        },

        async init () {
            let opt = {
                providerName: "Global",
                // providerKey: this.exhibition.id,
                names: ['StandardBoothConstructionChange.SubmitDeadline', 'StandardBoothConstructionChange.IsSubmitDeadlineToo', 'StandardBoothConstructionChange.IsRequired', 'StandardBoothConstructionChange.FormDescription', 'StandardBoothConstructionChange.ContractDescription']
            }
            let res = await this.setManageSettingQ(opt)
            if (res) {
                this.formList = res
            }
        },
        // 获取列表
        async init2 () {
            let res = await this.standardboothconstructionchangerecordGet(this.queryId);
            this.list[3].otherRemark = res.otherRemark
            this.creationTime = res.creationTime
            let data = JSON.parse(res.preBookJson)
            data.map(e => {
                if (e.name == '光地') {
                    this.list[0].remark = e.remark == '是' ? true : false
                }
                if (e.name == '增加展墙') {
                    this.list[1].remark = e.remark == '是' ? true : false
                }
                if (e.name == '拆除展墙，请注明要拆除的展墙两侧的展位号') {
                    this.list[2].remark = e.remark == '是' ? true : false
                }
            })
        },

    },
};
</script>

<style lang="scss" scoped>
.all-order {
    min-width: 1000px;
    padding: 30px;
    min-height: 500px;
   /deep/ .el-descriptions :not(.is-bordered) .el-descriptions-item__cell{
        width: 300px;
    }
    &-content {
        background: #FFF;

        .goods {
            width: 18%;
            padding: 10% 0;
            display: inline-block;
            position: relative;
            margin: 0 3px;

            img {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                max-width: 100%;
                max-height: 100%;
                margin: auto;
            }
        }

        .goods-e {
            position: absolute;
            left: 100%;
            top: 30%;
            font-weight: bold;
        }

        .operation {
            color: #1890ff;
            cursor: pointer;
        }
    }
}


</style>